/* tslint:disable */
/* eslint-disable */
/**
 * CourierCustomer
 * CourierCustomer
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { Courier, CourierFromJSON, CourierToJSON } from './Courier';
import { CourierUser, CourierUserFromJSON, CourierUserToJSON } from './CourierUser';

/**
 * 
 * @export
 * @interface CourierCustomer
 */
export interface CourierCustomer {
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    mailboxNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourierCustomer
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof CourierCustomer
     */
    courierId: string;
    /**
     *
     * @type {string}
     * @memberof CourierCustomer
     */
    trnNumber?: string;
    /**
     *
     * @type {Date}
     * @memberof CourierCustomer
     */
    createdOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CourierCustomer
     */
    lastUpdatedOn?: Date;
    /**
     * 
     * @type {Courier}
     * @memberof CourierCustomer
     */
    courier?: Courier;
    /**
     * 
     * @type {CourierUser}
     * @memberof CourierCustomer
     */
    subCourierUser?: CourierUser;
}

/**
 * Check if a given object implements the CourierCustomer interface.
 */
export function instanceOfCourierCustomer(value: object): value is CourierCustomer {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('courierId' in value) || value['courierId'] === undefined) return false;
    return true;
}

export function CourierCustomerFromJSON(json: any): CourierCustomer {
    return CourierCustomerFromJSONTyped(json, false);
}

export function CourierCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierCustomer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'mailboxNumber': json['mailboxNumber'] == null ? undefined : json['mailboxNumber'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'customerId': json['customerId'],
        'courierId': json['courierId'],
        'trnNumber': json['trnNumber'] == null ? undefined : json['trnNumber'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'lastUpdatedOn': json['lastUpdatedOn'] == null ? undefined : (new Date(json['lastUpdatedOn'])),
        'courier': json['courier'] == null ? undefined : CourierFromJSON(json['courier']),
        'subCourierUser': json['subCourierUser'] == null ? undefined : CourierUserFromJSON(json['subCourierUser']),
    };
}

export function CourierCustomerToJSON(json: any): CourierCustomer {
    return CourierCustomerToJSONTyped(json, false);
}

export function CourierCustomerToJSONTyped(value?: CourierCustomer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'mailboxNumber': value['mailboxNumber'],
        'isActive': value['isActive'],
        'externalId': value['externalId'],
        'customerId': value['customerId'],
        'courierId': value['courierId'],
        'trnNumber': value['trnNumber'],
        'createdOn': value['createdOn'] == null ? undefined : ((value['createdOn']).toISOString()),
        'lastUpdatedOn': value['lastUpdatedOn'] == null ? undefined : ((value['lastUpdatedOn']).toISOString()),
        'courier': value['courier'],
        'subCourierUser': value['subCourierUser'],
    };
}
